import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import { testimonialsData } from '@/mocks/homepage';

export default function Testimonials() {
  const { t } = useTranslation('homepage');
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal<HTMLDivElement>(0.15);
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section id="testimonials" className="bg-white py-20 md:py-28 lg:py-32">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        {/* Title */}
        <div
          ref={titleRef}
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('testimonials_h2')}
          </h2>
        </div>

        {/* Cards */}
        <div
          ref={cardsRef}
          className={`grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 transition-all duration-1000 delay-200 ${
            cardsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {testimonialsData.map((item, index) => (
            <div
              key={item.id}
              className="bg-soft-gray rounded-lg p-6 md:p-8 hover:shadow-md transition-all duration-300"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-slate-primary text-sm md:text-base leading-relaxed mb-6">
                &ldquo;{t(item.textKey)}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0"
                  style={{ backgroundColor: item.color }}
                >
                  {item.initials}
                </div>
                <div>
                  <p className="font-semibold text-slate-primary text-sm">
                    {t(item.nameKey)}
                  </p>
                  <p className="text-gray-400 text-xs">
                    {t(item.locationKey)} — {t(item.projectKey)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-slate-primary/40 text-xs mt-8 text-center italic max-w-3xl mx-auto">
          Témoignages représentatifs de clients ayant utilisé notre service de mise en relation.
        </p>
      </div>
    </section>
  );
}